"use client";

import { Icon, IconProps } from "@iconify/react";

/**
 * Refer: https://icon-sets.iconify.design/ic/baseline-add-a-photo
 */
const IconDefault = ({ icon, ...rest }: IconProps) => {
  return <Icon icon={icon} fontSize="1.5rem" {...rest} />;
};

export default IconDefault;
